module.exports = __webpack_public_path__ + "img/banner.f7fdee7b.jpeg";